// src/components/practice/tasks/writing/parsers/advertisementParser.js
// Parser for advertisement/flyer content to format it nicely

export const parseAdvertisementContent = (content) => {
    if (!content) return null;

    const result = {
        companyName: '',
        intro: '',
        sections: [],
        footer: []
    };

    // Split by newlines first
    const lines = content.split('\n').filter(line => line.trim());

    // If there's only one line, try to split by section headers (text followed by colon)
    const fullText = lines.join(' ');

    // Extract company name (first part before any punctuation or section header)
    const companyMatch = fullText.match(/^([^.!?:]+?)(?=\.|!|\?|[A-Z][a-zäöü]+\s+\d+)/);
    if (companyMatch) {
        result.companyName = companyMatch[1].trim();
    }

    // Find section headers (words followed by colon)
    const sectionPattern = /([A-ZÄÖÜ][^:]+?):\s*/g;
    const sections = [];
    let lastIndex = 0;
    let match;

    while ((match = sectionPattern.exec(fullText)) !== null) {
        const header = match[1].trim();
        const startIndex = match.index;

        // Get content before this section (intro or previous section content)
        if (sections.length === 0 && startIndex > 0) {
            let introText = fullText.substring(0, startIndex).trim();
            // Remove company name from intro
            if (result.companyName) {
                introText = introText.replace(result.companyName, '').trim();
            }
            result.intro = introText;
        }

        sections.push({
            header: header,
            startIndex: match.index + match[0].length,
            endIndex: -1
        });

        // Set end index for previous section
        if (sections.length > 1) {
            sections[sections.length - 2].endIndex = match.index;
        }
    }

    // Set end index for last section
    if (sections.length > 0) {
        sections[sections.length - 1].endIndex = fullText.length;
    }

    // Extract content for each section
    sections.forEach(section => {
        const sectionContent = fullText.substring(section.startIndex, section.endIndex).trim();

        // Split by commas or periods to create bullet points
        let items = [];
        if (sectionContent.includes(',')) {
            // Split by comma for list items
            items = sectionContent.split(',').map(item => item.trim()).filter(Boolean);
        } else if (sectionContent.includes('.')) {
            // Split by period for sentences
            items = sectionContent.split('.').map(item => item.trim()).filter(Boolean);
        } else {
            items = [sectionContent];
        }

        result.sections.push({
            header: section.header,
            items: items
        });
    });

    // If no sections were found, treat everything after company name as intro
    if (result.sections.length === 0 && result.companyName) {
        result.intro = fullText.replace(result.companyName, '').trim();
    }

    // Try to extract footer (contact info) from last section or intro
    const contactPattern = /([A-ZÄÖÜ][a-zäöü]+(?:\s+[A-ZÄÖÜ][a-zäöü]+)*,?\s+[A-ZÄÖÜ][a-zäöüß]+\.\s+\d+,?\s+\d{5}\s+[A-ZÄÖÜ][a-zäöü]+(?:,?\s+Tel[.:]?\s*[\d\s\/]+)?(?:,?\s+E-Mail:\s*[\w.@-]+)?)/;
    const contactMatch = fullText.match(contactPattern);

    if (contactMatch) {
        result.footer = contactMatch[1].split(',').map(item => item.trim()).filter(Boolean);

        // Remove footer from the last section
        if (result.sections.length > 0) {
            const lastSection = result.sections[result.sections.length - 1];
            lastSection.items = lastSection.items.filter(item =>
                !result.footer.some(footerItem => item.includes(footerItem))
            );
        }
    }

    console.log('Parsed advertisement:', result);
    return result;
};